export enum EmployeeTypeEnum {
  Office = "Working from office",
  Home = "Working from home",
  Inactive = "Inactive",
  ParentalLeave = "Parental leave",
  Inside = "Still inside",
}
